import React from 'react'
import { Contributions } from 'Utilities/Plans/ContributionCalculator'
import { TieredRates } from 'Utilities/pharaoh.types'
import PlanTitle from '../plan-subcomponents/PlanTitle'
import { Label } from 'Utilities/config'
import styles from './index.module.scss'
import Plan, { PlanBody } from '../plan-subcomponents/Plan'
import SupplementalPlan from '../SupplementalPlan/index.helpers'
import PremiumBreakdown, { isEmployerProps, EmployerProps } from '../plan-subcomponents/PremiumBreakdown'
import { GlobalStringConstant } from 'GlobalStringConstant'
import BenifitAmountComp from './ERSupplementalSubComp/BenifitAmountComp'
import PeriodComp from './ERSupplementalSubComp/PeriodComp'

interface Props {
  plan: { rate: TieredRates, plan: SupplementalPlan, isRenewal: boolean }
  contributions: Contributions
  selected?: boolean
  selectHandler?(plan: SupplementalPlan): void
  label: Label
  showWeeklyPayments: boolean
}

const HospitalPlan: React.FC<EmployerProps & Props> = (props) => {
  const { plan, selected, selectHandler, label, contributions, showWeeklyPayments } = props
  const sbc = plan.plan.data.sbc
  const hospitalConfinementBenefit = plan?.plan?.data?.hospitalConfinementBenefit.match(/(?:[$])([0-9]+(.[0-9]+)?)/)[1]
  const benefitInterval = plan?.plan?.data?.hospitalConfinementBenefit.substr(plan?.plan?.data?.hospitalConfinementBenefit.indexOf(' ') + 1)
  const hospitalShortStay = (plan?.plan?.data?.hospitalShortStay).replace('benefit for hospital stay less tan 23 hours. 2 payment man per Calendar year', 'benefit for hospital stay less than 23 hours')
  const emergencyRoomBenefit = (plan?.plan?.data?.emergencyRoomBenefit).split(' ')[0]

  return <Plan selected={!!selected}>
    <PlanTitle
      id={plan.plan.id}
      planName={plan.plan.name}
      carrier= {plan.plan.carrier}
      selected={selected}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
      includesProsperBenefits={false}
      planType={props.plan.plan.type}
      label={label}
      sbc={sbc}
    />
    <PlanBody>
      {breakdown()}
      <BenifitAmountComp benifitAmount={hospitalConfinementBenefit} name={GlobalStringConstant[0].hospital_confinement_benefit} benifitLabel={benefitInterval}/>
      <div className={`${styles.endSection} ${styles.fourSpecs} ${styles.half_height}`}>
        <PeriodComp compName={GlobalStringConstant[0].emergency_room_benefit} daysOrWeak={emergencyRoomBenefit} label={GlobalStringConstant[0].payment_max_per_calendar_year}/>
        <PeriodComp compName={GlobalStringConstant[0].hospital_short_stay} daysOrWeak={hospitalShortStay} label={GlobalStringConstant[0].payment_max_per_calendar_year}/>
      </div>
    </PlanBody>
  </Plan>
  function breakdown() {
    const base = { plan, contributions, showWeeklyPayments }
    if (isEmployerProps(props)) {
      return <PremiumBreakdown {...base} members={props.members} />
    }
  }
}

export default HospitalPlan
